module.exports = __webpack_public_path__ + "media/images/default/join_us/doctor-52db20ecc5f0e4b01e1f23b713e08dba.jpg";